define(
    'views/secured/explorer/results/results.html',[
        "viewmodels/secured/explorer/context",
        "durandal/system",
        "durandal/app",
        "services/config",
        "services/eventbroker",
        "services/service.documents",
        "viewmodels/secured/explorer/details/details",
        "providers/dataprovider",
        "i19n!i19n/strings",
        "plugins/router",
        "viewmodels/secured/explorer/details/documentClipboard", "services/service.dialog", "services/service.documents"
    ],
    function (ctx, system, app, config, eventBroker, documentService, details, dataProvider, i19n, router, documentClipboard, dialogService, documentsService) {
        var $menu = null;
        var $original = null;
        var resultsGrid = null;
        var view = {};

        var $wndColumn = null;
        var wndColumn = null;

        var dictionary = {};

        view.compositionComplete = function (html, parentHtml, ctxDetails) {
            view.viewModel = ctxDetails.model;
            view.filterValue = "";

            initializeGridRenderingHandlers($("#results-grid", html));

            var $filterIcon = $("#results-filter-icon", html);
            var $filter = $("#results-filter-input", html);
            var $filterClear = $("#results-filter-icon-clear", html);

            $filterIcon.mouseover(function () {
                $filterIcon.click();
            });
            $filterIcon.click(function () {
                $("#results-filter > .filter-text", html).width(120);
                $("#results-filter i#results-filter-icon-clear", html).show();
                $("#results-filter #results-filter-input", html).show();
                $("#results-filter #results-filter-input", html).focus();

                $("#results-filter-icon").removeClass("enabled");
                $("#results-filter-icon").addClass("disabled");
            });
            $filterClear.click(function () {
                if ($filter.val() != "") {
                    $filter.val("");
                    $filter.trigger("focusout");
                }
            });
            //$filter.focus(function () {
            //    $("#results-filter > .filter-text", html).width(120);
            //    $("#results-filter i#results-filter-icon-clear", html).show();
            //});
            $filter.focusout(function () {
                if ($filter.val() == "") {
                    $("#results-filter > .filter-text", html).width(20);
                    $("#results-filter i#results-filter-icon-clear", html).hide();
                    $("#results-filter #results-filter-input", html).hide();

                    $("#results-filter-icon").removeClass("disabled");
                    $("#results-filter-icon").addClass("enabled");

                    if(view.filterValue != "")
                        eventBroker.trigger(view, config.events.explorer.results.filterby, { type: "default", value: "" });

                    view.filterValue = "";
                } else {                    
                    eventBroker.trigger(view, config.events.explorer.results.filterby, { type: "fields", value: $filter.val(), operator: "contains" });

                    view.filterValue = $filter.val();
                }                
            });
            $filter.keypress(function (e) {
                var key = e.which;
                if (key == 13) {
                    $filter.blur();
                }
            });

            $wndColumn = $("#context-column-menu-window");
            wndColumn = $wndColumn.kendoWindow({
                title: '',
                modal: true,
                visible: false,
                resizable: false,
                width: 500
            }).data('kendoWindow');

            var _$menu = $("#menu");

            $original = _$menu.clone(true);
        };
        view.resizeGrid = resizeGrid;

        var resultsGrid_dataBound = function (args) {
            var self = this;
            var resultsGrid = args.sender;
            var total = resultsGrid.dataSource.total();
            var resultCount = total ? String.format("{0}", total) : "0";

            $("#results-grid tr.k-alt").removeClass("k-alt");            

            var isAdmin = resultsGrid.options.viewModel.session.role == 3 || resultsGrid.options.viewModel.session.role == 4 ? true : false;

            resultsGrid.options.viewModel.resultCount(resultCount);            
            
            $("#results-grid").on("mouseover", "td", function (e) {
                if ($(e.currentTarget).find("div#results-action-bar").length > 0)
                    return;

                e.currentTarget.title = e.currentTarget.outerText;
            });
            
            for (var i = 0; i < details.checkedDocuments().length; i++) {
                var row = resultsGrid.dataSource.get(details.checkedDocuments()[i].documentId);

                if (row) {
                    row.checked = true;

                    //resultsGrid.tbody
                    //.find("tr[data-uid='" + row.uid + "']")
                    //.find(":checkbox", ".results-grid-data-action").prop("checked", true);

                    resultsGrid.tbody
                    .find("tr[data-uid='" + row.uid + "']")
                    .find('input:checkbox[class="checkbox-action-results-grid"]', ".results-grid-data-action").prop("checked", true);                    
                }
            }
            for (var i = 0; i < resultsGrid.dataSource.data().length; i++) {
                var itm = resultsGrid.dataSource.data()[i];
                var $row = self.tbody.find("tr[data-uid='" + itm.uid + "']");
                
                /*
                from chris comment: there is no checkout field status=2 is checkedout isreadonly, ispublished are the other 2
                */

                if ($row.length > 0 && itm.status == 2) {
                    $row.css({ 'background-color': '#f2dede' });
                }

                //console.warn(itm);
            }

            if (resultsGrid.options.viewModel.isDeleted) {
                $("#results-grid .k-virtual-scrollable-wrap").find("tr td:nth-child(n+3)").css({ "text-decoration": "line-through" });
            }
            
            if (isAdmin && !(!ctx.current.library || !ctx.current.library.libraryId)) {
                var $colMenu = $('<i id="context-column-menu-cog" style="font-size: 18px;position: absolute;right: 1px;top: 10px; cursor: pointer;" class="fa fa-cog"></i>');
                
                $colMenu.off("click", "**");
                $colMenu.on("click", function (e) {

                    //var $cog = $("#results-grid .k-grid-header").find("i.fa-cog");

                    var $cog = $(e.currentTarget);

                    if ($cog.hasClass("fa-cog")) {
                        resultsGrid.options.viewModel.columns.onSave = function () {
                            $(e.currentTarget).removeClass("cog-blue");
                            $(e.currentTarget).removeClass("fa-floppy-o");

                            dictionary[ctx.current.library.libraryId] = null;

                            eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.navigation.refresh, {});
                            eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.results.kendoGridColumnManage, { isShow: true });
                        };
                        resultsGrid.options.viewModel.columns.onReset = function () {
                            $(e.currentTarget).addClass("cog-blue");

                            dictionary[ctx.current.library.libraryId] = null;

                            sessionStorage.__isShowKendoGridColumnManage = '1';

                            eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.navigation.refresh, {});
                        };
                        resultsGrid.options.viewModel.columns.onClose = function () {
                            $(e.currentTarget).removeClass("cog-blue");
                            $("#results-grid .k-grid-header").find("i.fa").removeClass("cog-blue");

                            eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.results.kendoGridColumnManage, { isShow: true });
                        };

                        if ($(e.currentTarget).hasClass("cog-blue")) {
                            $(e.currentTarget).removeClass("cog-blue");
                            $(e.currentTarget).removeClass("fa-floppy-o");

                            eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.results.kendoGridColumnManage, { libraryId: ctx.current.library.libraryId, isShow: true });
                        } else {
                            resultsGrid.options.viewModel.columns.loadData(ctx.current.library.libraryId)
                            .done(function () {

                                $(e.currentTarget).addClass("cog-blue");

                                eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.results.kendoGridColumnManage, { isShow: false });
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        }
                    }
                    if ($(e.currentTarget).hasClass("fa-floppy-o")) {

                        dataProvider.libraries
                        .getDisplay(ctx.current.library.libraryId)
                        .done(function (data) {
                            var disp = _.map(_.filter(data.columnsToDisplay, function (itm) { return itm.fieldName.length > 0; }), function (itm) {
                                return {
                                    fieldName: itm.fieldName,
                                    documentFieldId: itm.documentFieldId
                                };
                            });

                            var taken = [];
                            _.map(resultsGrid.columns, function (itm) {
                                var b = _.find(disp, function (t) {
                                    return t.fieldName.toLowerCase() == itm.title.toLowerCase();
                                });

                                if (b) {
                                    taken.push(b);
                                }
                            });

                            if (taken.length > 0) {
                                dataProvider.libraries
                                .updateDisplay(ctx.current.library.libraryId, taken)
                                .done(function (data) {
                                    dictionary[ctx.current.library.libraryId] = null;

                                    $(e.currentTarget).removeClass("fa-floppy-o");
                                    $(e.currentTarget).addClass("fa-cog");
                                })
                                .fail(function (e) {
                                    console.error(e);
                                });
                            }
                        })
                        .fail(function (e) {
                            console.error(e);
                        });
                    }

                    //console.warn($cog);
                });

                $("#results-grid .k-grid-header").append($colMenu);

                if (!!sessionStorage.__isShowKendoGridColumnManage && sessionStorage.__isShowKendoGridColumnManage === '1') {
                    resultsGrid.options.viewModel.columns.loadData(ctx.current.library.libraryId)
                    .done(function () {
                        eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.results.kendoGridColumnManage, { libraryId: ctx.current.library.libraryId, isShow: false });

                        $("#results-grid .k-grid-header").find("i.fa").addClass("cog-blue");
                    })
                    .fail(function (e) {
                        console.error(e);
                    });

                    sessionStorage.__isShowKendoGridColumnManage = '';
                } else {
                    $("#results-grid .k-grid-header").find("i.fa").removeClass("cog-blue");

                    eventBroker.trigger(resultsGrid.options.viewModel, config.events.explorer.results.kendoGridColumnManage, { isShow: true });
                }
            }
            
            if (sessionStorage.__url_documentId) {
                selectResultsGridDocument(sessionStorage.__url_documentId);
            }

            setTimeout(function () {
                resizeGrid();
            }, 1500);
            

            if ($menu) {
                var clone = $original.clone(true);

                $menu.getKendoContextMenu().destroy();

                clone.appendTo("#explorer-results");
            }

            initMenu();
     
            function initMenu() {
                //result.js line 476
                //var _rowSelected = null;
                $menu = $("#menu").kendoContextMenu({
                    target: $("#results-grid"),
                    animation: false,
                    filter: 'tr[tabindex="0"]',

                    open: function (e) {
                        $(e.target).trigger("click");

                        //var r = $("#results-grid").data("kendoGrid");
                        //var itm = r.dataItem($(e.target));

                        //_rowSelected = itm;

                        //var $row = $(r.table.find("tr[data-uid='" + itm.uid + "']")[0]);

                        //r.table.find("tr.k-state-selected").removeClass("k-state-selected");
                        //$row.addClass("k-state-selected");

                        //console.warn(e);
                        //console.warn(itm);
                    },
                    select: function (e) {
                        var rr = $("#results-grid").data("kendoGrid");
                        var itm = rr.dataItem(rr.select());

                        if (!itm) {
                            console.warn("no selected row after context");
                            return;
                        }

                        var mnuId = $(e.item).attr("data-id");
                        if (mnuId === "mnu-grid-copy-link") {
                            copyTextToClipboard(sessionStorage.__url, "Document link copied");
                        }
                        if (mnuId === "mnu-grid-copy-documents") {
                            var documents = [];

                            documents.push(itm);

                            documentsService.actions.canCopyDocuments(documents)
                            .done(function (result) {
                                var promise;

                                if (!result.success) {
                                    promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal", [result]);
                                } else {
                                    var _i19n = {
                                        action: {
                                            name: i19n.to.copydocuments,
                                            message: i19n.to.copytheselecteddocumentsinto
                                        },
                                        dialogoptions: {
                                            ok: {
                                                label: i19n.to.okay,
                                                message: i19n.to.documentscopiedtodocumentclipboardnavigatetocopy
                                            },
                                            cancel: {
                                                label: i19n.to.cancel,
                                                message: i19n.to.removethedocumentsfromthedocumentclipboardandclose
                                            }
                                        }
                                    };

                                    promise = dialogService.showMessageBox(
                                        String.format(i19n.to._documentscopiedtothedocument, documents.length),
                                        i19n.to.usethefoldermenutoduplicate,
                                        _.toArray(_i19n.dialogoptions)
                                    );

                                    promise.then(function (dialogResult) {
                                        if (dialogResult == _i19n.dialogoptions.ok) {
                                            documentClipboard.copy(documents);
                                        } else {
                                            documentClipboard.clear();
                                        }
                                    });
                                }

                                //promise.always(function(){});
                            });
                        }
                        if (mnuId === "mnu-grid-move-documents") {
                            var documents = [];

                            documents.push(itm);

                            documentsService.actions.canMoveDocuments(documents)
                            .done(function (result) {
                                var promise;

                                if (!result.success) {
                                    promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal", [result]);
                                } else {
                                    var _i19n = {
                                        action: {
                                            name: i19n.to.movedocuments,
                                            message: i19n.to.movetheselecteddocumentsinto
                                        },
                                        dialogoptions: {
                                            ok: {
                                                label: i19n.to.okay,
                                                message: i19n.to.documentscopiedtodocumentclipboardnavigatetomove
                                            },
                                            cancel: {
                                                label: i19n.to.cancel,
                                                message: i19n.to.removethedocumentsfromthedocumentclipboardandclose
                                            }
                                        }
                                    };

                                    promise = dialogService.showMessageBox(
                                        String.format(i19n.to._documentscopiedtothedocument, documents.length),
                                        i19n.to.usethefoldermenutomove,
                                        _.toArray(_i19n.dialogoptions)
                                    );

                                    promise.then(function (dialogResult) {
                                        if (dialogResult == _i19n.dialogoptions.ok) {
                                            ctx.pfolder = ctx.current.folder;

                                            documentClipboard.cut(documents);
                                        } else {
                                            ctx.pfolder = null;

                                            documentClipboard.clear();
                                        }
                                    });
                                }

                                //promise.always(function () { });
                            });
                        }
                        if (mnuId === "mnu-grid-replace-file") {
                            var documents = [];

                            documents.push(itm);

                            documentsService.actions
                            .canReplaceFile(documents)
                            .done(function (result) {
                                if (!result.success) {
                                    dialogService.showDocumentActionErrorDialog(result).then(function () { });
                                } else {
                                    //complete();

                                    router.navigate("actionsReplaceFile");
                                }
                            });
                        }
                        if (mnuId === "mnu-grid-checkin") {
                            var documents = [];

                            documents.push(itm);

                            documentsService.actions
                                .canCheckin(documents)
                                .done(function (result) {
                                    if (!result.success) {
                                        dialogService.showDocumentActionErrorDialog(result).then(function () { });
                                    } else {

                                        //complete();

                                        router.navigate("actionsCheckIn");
                                    }
                                });
                        }
                        if (mnuId === "mnu-grid-checkout") {
                            var documents = [];

                            documents.push(itm);

                            documentsService.actions
                                .canCheckout(documents)
                                .done(function (result) {
                                    var promise;

                                    if (!result.success) {
                                        promise = dialogService.showDocumentActionErrorDialog(result);
                                    } else {
                                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionCheckOutModal", '');

                                        promise.then(function (dialogResult) {
                                            if (dialogResult.checkout) {
                                                var documentId = documents.length == 1 ? documents[0].documentId : null;

                                                documentsService.actions.checkoutDocuments(documents)
                                                .done(function () {
                                                    eventBroker.trigger(view, config.events.explorer.navigation.checkoutCount, null);
                                                })
                                                .fail(function (e) {
                                                    e.stopPropagation = true;

                                                    //self.errors(e.error);

                                                    console.error(e);
                                                })
                                                .always(function () {
                                                    ctx.onReloadFolders({ documentId: documentId });

                                                    //complete();
                                                });
                                            }
                                            else {
                                                //complete();
                                            }
                                        });
                                    }

                                    //promise.always(function(){});
                                });
                        }
                        if (mnuId === "mnu-grid-cancel-checkout") {
                            var documents = [];

                            documents.push(itm);

                            var documentId = documents.length == 1 ? documents[0].documentId : null;
                            var promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionCancelCheckOut", '');

                            promise.then(function (dialogResult) {
                                if (dialogResult.cancelcheckout) {
                                    documentsService.actions
                                    .cancelCheckOutDocuments(documents)
                                    .done(function () {
                                        eventBroker.trigger(view, config.events.explorer.navigation.checkoutCount, null);
                                    })
                                    .fail(function (e) {
                                        e.stopPropagation = true;

                                        //self.errors(e.error);

                                        console.error(e);
                                    })
                                    .always(function () {
                                        ctx.onReloadFolders({ documentId: documentId });

                                        //complete();
                                    });
                                } else {
                                    //complete();
                                }
                            });

                            //promise.always(function(){});
                        }
                        if (mnuId === "mnu-grid-delete") {
                            var documents = [];

                            documents.push(itm);

                            documentsService.actions
                                .canDelete(documents)
                                .done(function (result) {
                                    var promise;

                                    if (!result.success) {
                                        promise = dialogService.showDocumentActionErrorDialog(result);
                                    } else {
                                        promise = dialogService.showDialog("modals/secured/explorer/details/tabs/actions/DocumentActionDeleteModal", '');

                                        promise.then(function (dialogResult) {
                                            if (dialogResult.deleting) {
                                                //_.map(documents, function (itm) {
                                                //    eventBroker.trigger(view, config.events.explorer.results.kendoGridRowMarkDirty, { docId: itm.docId });
                                                //});

                                                documentsService.actions
                                                .deleteDocuments(documentClipboard.toDocumentLocationList(documents))
                                                .done(function () {
                                                })
                                                .fail(function (e) {
                                                    e.stopPropagation = true;

                                                    self.errors(e.error);

                                                    console.warn(e);
                                                })
                                                .always(function () {
                                                    require(["viewmodels/secured/explorer/navigation/menu"], function (menu) {
                                                        if (menu.currentItem().id == 'library') {
                                                            if (!(!ctx.current || !ctx.current.folder)) {
                                                                ctx.onReloadFolders({ isUpdateNodeOnly: true, folderId: ctx.current.folder.folderId, _updateNode: { docCount: ctx.current.folder.docCount - documents.length, text: ctx.current.folder.name() } });
                                                            }
                                                        } else {
                                                            //ctx.onDocument(null); //this is perform in filterBy
                                                        }

                                                        eventBroker.trigger(view, config.events.explorer.results.filterby, { type: 'refresh' });
                                                    });

                                                    //complete();
                                                });
                                            } else {
                                                //complete();
                                            }
                                        });
                                    }

                                    //promise.always(function(){});
                                });
                        }

                    }
                });
            }
        };

        eventBroker.on(view, config.events.explorer.results.filterby, function (data) {
            ctx.onDocument(null);

            if (resultsGrid != null) {
                data.operator = data.operator || 'eq';
                
                if (data.type == 'refresh') {
                    resultsGrid.dataSource.read();
                }
                if (data.type == 'default') { //resultsGrid.dataSource.transport.options.read.url = function () { return resultsGridUrl; };
                    resultsGrid.dataSource.filter([]);
                }
                if (data.type == 'email') {
                    resultsGrid.dataSource.filter([{ field: 'documentClass', operator: data.operator, value: '1' }]);
                }
                if (data.type == 'controlled') {
                    resultsGrid.dataSource.filter([{ field: 'documentClass', operator: data.operator, value: '2' }]);
                }
                if (data.type == 'working') {
                    resultsGrid.dataSource.filter([{ field: 'documentClass', operator: data.operator, value: '0' }]);
                }
                if (data.type == 'field') {
                    resultsGrid.dataSource.filter([{ field: data.field, operator: data.operator, value: data.value }]);
                }
                if (data.type == 'fields') {

                    var isDate = kendo.parseDate(data.value.toString()) != null;
                    var isDecimal = $.isNumeric(data.value) ? (parseFloat(data.value) % 1) > 0 : false;
                    var isInteger = !isDecimal ? $.isNumeric(data.value) : false;
                    var isBoolean = data.value == "true" || data.value == "false" ? true : false;
                    var columns = _.filter(resultsGrid.columns, function (itm) { return itm.filterable; });
                    var filters = [];

                    if (isDate) {
                        data.value = kendo.toString(kendo.parseDate(data.value), "yyyy-MM-dd hh:mm tt");  
                    }

                    columns = _.filter(columns, function (column) {
                        if ((!column.isDate && isDate) || (column.isDate && !isDate))
                            return false;
                        if (column.isDecimal && !isDecimal)
                            return false;
                        if (column.isInteger && !isInteger)
                            return false;
                        if (column.isBoolean && !isBoolean)
                            return false;

                        return true;
                    });                                       

                    _.map(columns, function (column) {
                        //column.operator = function (item, val) {
                        //    var searchText = "";

                        //    if (item instanceof kendo.data.ObservableArray && column.type.toLowerCase() == "foreignkey") {
                        //        _.each(item, function (arrayItem) {
                        //            searchText += arrayItem.label + " ";
                        //        });
                        //    } else {
                        //        searchText = column.formatter ? kendo.toString(item, column.formatter) : item.toString();
                        //    }
                        //    console.warn(searchText);
                        //    console.warn(val);
                        //    return item != null && searchText.toLowerCase().indexOf(val.toLowerCase()) >= 0;
                        //}

                        //column.formatter ? kendo.toString(item, column.formatter);

                        
                        //console.warn(kendo.toString(data.value, column.formatter));

                        filters.push({ field: column.field, value: data.value, operator: column.operator });
                    });                    

                    resultsGrid.dataSource.filter({
                        logic: "or",
                        filters: filters
                    });
                }
            }
        });
        eventBroker.on(view, config.events.explorer.layout.resizedResultsPane, function () {
            if (resultsGrid) {
                resizeGrid();
            }
        });
        eventBroker.on(view, config.events.explorer.results.kendoGridRowUpdateColumn, function (data) {
            if (resultsGrid) {
                if (data && data.documentId && data.field) {
                    var q = _.findWhere(resultsGrid.columns, { field: data.field });
                    
                    if (q) {
                        var row = resultsGrid.dataSource.get(data.documentId);

                        if (row && row[data.field] !== undefined) {
                            row.set(data.field, data.value);
                        }
                    }
                }
            }
        });        
        eventBroker.on(view, config.events.explorer.results.kendoGridRowMarkDirty, function (data) {
            if (resultsGrid && data) {
                if (data.documentId) {
                    var row = resultsGrid.dataSource.get(data.documentId);

                    if (row)
                        row.set("_oid", null);
                }
                if (data.docId) {
                    for (i = 0; i < resultsGrid.dataSource.data().length; i++) {
                        var row = resultsGrid.dataSource.data()[i];

                        if (row && row.docId == data.docId) {
                            row.set("_oid", null);
                        }
                    }
                }
            }
        });
        eventBroker.on(view, config.events.header.show, function (data) {
            if (data.isShow) {
                $("#results-heading").find(".suffix").show();
                $("#results-filter").show();
                window.fp.explorerLayout.open("west");
                window.fp.explorerLayout.open("east");
            } else {
                $("#results-heading").find(".suffix").hide();
                $("#results-filter").hide();
                window.fp.explorerLayout.close("west");
                window.fp.explorerLayout.close("east");
            }
        });        

        return view;

        function selectResultsGridDocument(documentId) {
            if (!documentId)
                return;

            var row = resultsGrid.dataSource.get(documentId);

            if (!row) {
                //added to accomodate upload as new version
                //due to webapi not returning documentId
                row = _.find(resultsGrid.dataSource.data(), function (itm) { return itm.currentDocumentFileId == documentId });

                if (row)
                    documentId = row.documentId;
                else
                    return;
            }

            var $row = $(resultsGrid.table.find("tr[data-uid='" + row.uid + "']")[0]);

            resultsGrid.table.find("tr.k-state-selected").removeClass("k-state-selected");
            resultsGrid.select($row);

            //$row.trigger("click");

            return $row;
        }

        function initializeGridRenderingHandlers($grid) {
            var $cloned = $grid.clone();            

            ctx.onNavSearch.subscribe(function (data) {
                documentService.getSearchedDocumentsConfig("search/metadata" + data.query).done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                    
                    eventBroker.trigger(view, config.events.explorer.results.kendoGridColumnManage, { isShow: true });
                });
            });
            ctx.onNavFavoriteFolder.subscribe(function (folder) {
                if (folder) {
                    documentService
                    .getLibraryDocumentsConfig(folder.libraryId)
                    .done(function (configuration) {
                        configuration.folderId = folder.folderId;
                        initGrid(configuration.createResultsGrid, null);
                    });
                }
            });
            ctx.onNavFavoriteSearch.subscribe(function (data) {                
                documentService.getSearchedDocumentsConfig("search/metadata?" + toQueryString(data.q)).done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                });                
            });
            ctx.onNavFavoriteDocument.subscribe(function (data) {
                documentService.getFavouriteDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                });
            });
            ctx.onNavFlagged.subscribe(function (data) {
                documentService.getFlaggedDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                });
            });
            ctx.onNavRecent.subscribe(function (data) {
                documentService.getRecentDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                });
            });
            ctx.onNavMyCheckedOut.subscribe(function (data) {
                documentService.getMyCheckedOutDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null, function () {
                        eventBroker.trigger(view, config.events.explorer.navigation.checkoutCount, null);
                    });
                });
            });
            ctx.onNavAllCheckedOut.subscribe(function (data) {
                documentService.getAllCheckedOutDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null, function () {
                        eventBroker.trigger(view, config.events.explorer.navigation.checkoutCount, null);
                    });
                });
            });
            ctx.onNavFolder.subscribe(function (data) {
                var folder = !data ? null : data.folder;                

                if (folder) {
                    var libraryId = folder.libraryId;
                    var folderId = folder.folderId;
                    var documentId = data.documentId;

                    if (!dictionary[libraryId]) {
                        // go get the library document schema and settings
                        dictionary[libraryId] = { loaded: $.Deferred() };
                        documentService.getLibraryDocumentsConfig(libraryId).done(function (configuration) {
                            dictionary[libraryId].configuration = configuration;
                            dictionary[libraryId].loaded.resolve(dictionary[libraryId]);
                        });
                    } else if (dictionary[libraryId].selectedFolder) {
                        dictionary[libraryId].loaded.resolve(dictionary[libraryId]);
                    }

                    // ensure the library document schema and settings have been loaded before acting on the folder selection.
                    dictionary[libraryId].loaded.done(function (result) {
                        dictionary[libraryId].selectedFolder = ctx.current.folder;
                        result.configuration.libraryId = libraryId; // used by the datasource to pull back the correct data
                        result.configuration.folderId = folderId;   // used by the datasource to pull back the correct data                        

                        initGrid(result.configuration.createResultsGrid, documentId);
                    });
                }
            });
            ctx.onNavFolderShowDeleted.subscribe(function (data) {
                if (!!data && !!data.libraryId && !!data.folderId) {
                    documentService.getLibraryDocumentsShowDeletedConfig(data.libraryId, data.folderId).done(function (configuration) {
                        initGrid(configuration.createResultsGrid, null);
                    });
                }
            });
            ctx.onNavFolderShowAll.subscribe(function (data) {
                if (!!data && !!data.libraryId && !!data.folderId) {
                    documentService.getLibraryDocumentsShowAllConfig(data.libraryId, data.folderId).done(function (configuration) {
                        initGrid(configuration.createResultsGrid, null);
                    });
                }
            });
            ctx.onNavMyDeleted.subscribe(function (data) {
                documentService.getDeletedDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                });
            });
            ctx.onNavAllDeleted.subscribe(function (data) {
                documentService.getAllDeletedDocumentsConfig().done(function (configuration) {
                    initGrid(configuration.createResultsGrid, null);
                });
            });
            
            ctx.onReloadResults.subscribe(function (data) {
                reloadResultsGrid(data);
            });                       

            function initGrid(createGridFn, documentId, dataComplete) {
                if (resultsGrid) {
                    resultsGrid.table.off("click", "tr", "**");
                    resultsGrid.table.off("click", ":checkbox", "**");
                    resultsGrid.table.off("click", "i.favourite", "**");
                    resultsGrid.table.off("click", "i.flag", "**");
                    $("#results-grid-header-action-toggle").off();
                    $("#results-grid-header-action-toggle1").off();
                    $('#results-grid-header-action-dropdown-all').off();
                    $('#results-grid-header-action-dropdown-none').off();
                    $('#results-grid-header-action-dropdown-flagged').off();
                    $('#results-grid-header-action-dropdown-unflagged').off();
                    $('#results-grid-header-action-dropdown-favourited').off();
                    $('#results-grid-header-action-dropdown-unfavourited').off();

                    $grid.off("mouseover", "td", "**");

                    resultsGrid.unbind("dataBound", resultsGrid_dataBound);

                    resultsGrid.dataSource.data([]);
                    //resultsGrid.dataSource.read();
                    resultsGrid.destroy();

                    $grid.empty();

                    var $parent = $grid.parent();
                    var styles = $grid.attr("style");

                    $grid.remove();
                    $grid = $cloned.clone();
                    $grid.attr("style", styles);
                    $parent.append($grid);
                }
                
                resultsGrid = createGridFn($grid, view.viewModel);

                $("#results-no-records").hide();

                documentService.dataCompleteCallback = function () {
                    selectResultsGridDocument(documentId);
                    
                    if (ctx.menu.currentItem().id == "search" && resultsGrid.dataSource.total() == 0) {
                        if ($("#results-heading").is(":visible"))
                            $("#results-heading").hide();
                        if ($("#results-filter").is(":visible"))
                            $("#results-filter").hide();
                        if ($("#results-grid").is(":visible"))
                            $("#results-grid").hide();
                        if ($("#results-action-bar-search").is(":visible"))
                            $("#results-action-bar-search").hide();

                        if (!$("#results-no-records").is(":visible"))
                            $("#results-no-records").show();
                    }
                    
                    if (dataComplete) {
                        dataComplete();
                    }

                    //filterFields = _.filter(resultsGrid.columns, function (itm) { return itm.filterable === true || itm.hidden === false; });
                    //filterFields = _.filter(resultsGrid.columns, function (itm) { return itm.hidden === false; });
                    //console.warn(filterFields);
                    //resultsGrid.options.viewModel.filterFields = _.map(filterFields, function (itm) { return { field: itm.field }; });
                    //console.warn(resultsGrid.options.viewModel.filterFields);
                }

                if (!$("#results-heading").is(":visible"))
                    $("#results-heading").show();
                if (!$("#results-filter").is(":visible"))
                    $("#results-filter").show();
                if (!$("#results-grid").is(":visible"))
                    $("#results-grid").show();
                if (!$("#results-action-bar-search").is(":visible"))
                    $("#results-action-bar-search").show();

                if ($("#results-no-records").is(":visible"))
                    $("#results-no-records").hide();                    
                
                resultsGrid.bind("dataBound", resultsGrid_dataBound);
            }            
        }

        function reloadResultsGrid(data) {            
            if (resultsGrid) {
                documentService.dataCompleteCallback = function () {
                    if (data && data.documentId) {
                        selectResultsGridDocument(data.documentId);
                    }
                }

                //resultsGrid.options.viewModel.clearHeader('all');
                resultsGrid.dataSource.read();
            }
        }
        function toQueryString(d) {
            var s = "";

            for (var property in d) {
                if (d.hasOwnProperty(property) && property != "savedSearchId" && property != "savedSearchName") {
                    var v = getVal(property, d[property]);
                    if (v != null) {
                        s = s + v + "&";
                    }
                }
            }

            return s;

            function getVal(property, a) {
                var s = "";

                if (Object.prototype.toString.call(a) === '[object Array]') {
                    for (var i = 0; i < a.length; i++) {
                        s = s + (property + "=" + a[i]) + (i < a.length - 1 ? "&" : "");
                    }
                } else {
                    if (a != null) {
                        if (property == "dateRangeFrom" || property == "dateRangeTo" || property == "dateReviewFrom" || property == "dateReviewTo") {
                            a = kendo.toString(new Date(a), "yyyy-MM-dd");
                        }
                        s = (property + "=" + a);
                    } else
                        s = null;
                }
                return s;
            }
        }
        function resizeGrid() {
            var $grid = $("#results-grid");

            var newGridHeight = $("#explorer-results").outerHeight(true) - $("#results-heading", "#explorer-results").outerHeight(true) - $("#results-action-bar-search", "#explorer-results").outerHeight(true);

            $grid.height(newGridHeight);
            $grid.data("kendoGrid").resize();

            var offset = $("#results-grid-header-action-toggle").offset();
            
            //if (!$("#results-grid-header-action-dropdown").is(":visible"))
                //$("#results-grid-header-action-dropdown").show();
            $("#results-grid-header-action-dropdown").offset({ top: offset.top + 20, left: offset.left });

            $(".dropzone").height(newGridHeight - 120);
        }

        function copyTextToClipboard(text, msg) {
            var textArea = document.createElement("textarea");

            // Place in top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;
            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;
            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            // Avoid flash of white box if rendered for any reason.
            textArea.style.background = 'transparent';
            textArea.style.resize = "none";
            textArea.value = text;
            textArea.style.overflow = "hidden";
            textArea.style.zIndex = "1";

            document.body.appendChild(textArea);

            textArea.select();

            try {
                var successful = document.execCommand('copy');
                //var msg = successful ? 'successful' : 'unsuccessful';
                //console.warn('Copying text command was ' + msg);

                if (successful) {
                    toastr.success(!msg ? "Address link copied." : msg);
                }
            } catch (e) {
                console.error(e);

                toastr.error(e);
            }

            document.body.removeChild(textArea);
        }
    });
